var $ = require('jquery');

$(function () {
    
    $('body').on('click', '.dropdown-filter', function () {
        $('.dropdown-filter-label').not(this).removeClass('open');
        $('.dropdown-filter').not(this).removeClass('open');
        $(this).toggleClass('open');
    });
    
    $('body').on('click', '.dropdown-filter, .dropdown-filter-list', function (e) {
        e.stopPropagation();
    });

    $('body').on('click', '.dropdown-filter-label', function () {
        $('.dropdown-filter-label').removeClass('open');
        $('.dropdown-filter').removeClass('open');
        $(this).toggleClass('open');
        $('.dropdown-filter-list').toggleClass('open');
    });

    $('body').on('click', function () {
        $('.dropdown-filter-label').removeClass('open');
        $('.dropdown-filter').removeClass('open');
    });

    $('.our-firms__show-more').each(function () {
        $(this).on('click', function () {
            $(this).parents('.our-firms__firm').toggleClass('show-more');
        });
    });
});
